'use client';

import { FC } from 'react';
import { shallow } from 'zustand/shallow';

import { Icon } from 'src/general/Icons/Icon';
import { modalStore } from 'src/stores/modalStore';

import { HeaderMenuAction } from './HeaderMenuAction';

export const HeaderMenuActionSearch: FC = () => {
  const { openModal } = modalStore(
    (state) => ({
      openModal: state.openModal,
    }),
    shallow,
  );

  return (
    <HeaderMenuAction title="Open search" data-testid="header-menu-button-search" onClick={() => openModal('search')}>
      <Icon name="search" />
    </HeaderMenuAction>
  );
};
